import { ReactElement } from 'react';

export const Calendar = (): ReactElement | null => {
    return null; // this component will be developed in future steps
};
